import { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { TopBar } from "./components/TopBar";
import { Sidebar } from "./components/Sidebar";
import { AiChat } from "./components/AiChat";
import { Dashboard } from "./pages/Dashboard";
import { ProductList } from "./pages/ProductList";
import { ProductDetail } from "./pages/ProductDetail";
import { SupplierList } from "./pages/SupplierList";
import { IngredientList } from "./pages/IngredientList";
import { StoreList } from "./pages/StoreList";

const AudioQuery = lazy(() => import("./pages/AudioQuery"));
const BomDashboard = lazy(() => import("./pages/BomDashboard"));
const Warroom = lazy(() => import("./pages/Warroom"));
const OcrPage = lazy(() => import("./pages/OcrPage"));
const CameraPage = lazy(() => import("./pages/CameraPage"));
const MaintenancePage = lazy(() => import("./pages/MaintenancePage"));
const ProductionPage = lazy(() => import("./pages/ProductionPage"));
const InventoryPage = lazy(() => import("./pages/InventoryPage"));
const PricingPage = lazy(() => import("./pages/PricingPage"));
const RecipeKbPage = lazy(() => import("./pages/RecipeKbPage"));
const TraceabilityPage = lazy(() => import("./pages/TraceabilityPage"));
const PaperlessPage = lazy(() => import("./pages/PaperlessPage"));
const BuilderPage = lazy(() => import("./pages/BuilderPage"));
const AdminPage = lazy(() => import("./pages/AdminPage"));
const AuditLogPage = lazy(() => import("./pages/AuditLogPage"));
const StatusPage = lazy(() => import("./pages/StatusPage"));
const ImportPage = lazy(() => import("./pages/ImportPage"));
const IotHubPage = lazy(() => import("./pages/IotHubPage"));
const IntegrationsPage = lazy(() => import("./pages/IntegrationsPage"));
const DataSourcePage = lazy(() => import("./pages/DataSourcePage"));
const ReportsPage = lazy(() => import("./pages/ReportsPage"));
const OnboardingPage = lazy(() => import("./pages/OnboardingPage"));
const AutomationPage = lazy(() => import("./pages/AutomationPage"));
const AiOpsPage = lazy(() => import("./pages/AiOpsPage"));
const ProcurementPage = lazy(() => import("./pages/ProcurementPage"));
const CrmPage = lazy(() => import("./pages/CrmPage"));
const HrPage = lazy(() => import("./pages/HrPage"));
const CustomTablePage = lazy(() => import("./pages/CustomTablePage"));
const TemplateMarketplace = lazy(() => import("./pages/TemplateMarketplace"));

function Loading() {
  return <div className="text-center py-12 text-slate-400 text-sm">載入中...</div>;
}

function MainLayout() {
  return (
    <div className="h-screen flex flex-col bg-slate-50 overflow-hidden">
      <TopBar />
      <div className="flex flex-1 min-h-0">
        <Sidebar />
        <main className="flex-1 p-6 lg:p-8 pb-20 overflow-auto">
          <Suspense fallback={<Loading />}>
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/products" element={<ProductList />} />
              <Route path="/products/:id" element={<ProductDetail />} />
              <Route path="/suppliers" element={<SupplierList />} />
              <Route path="/ingredients" element={<IngredientList />} />
              <Route path="/stores" element={<StoreList />} />
              <Route path="/audio2sql" element={<AudioQuery />} />
              <Route path="/bom" element={<BomDashboard />} />
              <Route path="/warroom" element={<Warroom />} />
              <Route path="/ocr" element={<OcrPage />} />
              <Route path="/cameras" element={<CameraPage />} />
              <Route path="/maintenance" element={<MaintenancePage />} />
              <Route path="/production" element={<ProductionPage />} />
              <Route path="/inventory" element={<InventoryPage />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/recipe-kb" element={<RecipeKbPage />} />
              <Route path="/traceability" element={<TraceabilityPage />} />
              <Route path="/paperless" element={<PaperlessPage />} />
              <Route path="/builder" element={<BuilderPage />} />
              <Route path="/import" element={<ImportPage />} />
              <Route path="/iot-hub" element={<IotHubPage />} />
              <Route path="/automation" element={<AutomationPage />} />
              <Route path="/ai-ops" element={<AiOpsPage />} />
              <Route path="/procurement" element={<ProcurementPage />} />
              <Route path="/crm" element={<CrmPage />} />
              <Route path="/hr" element={<HrPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/audit" element={<AuditLogPage />} />
              <Route path="/status" element={<StatusPage />} />
              <Route path="/integrations" element={<IntegrationsPage />} />
              <Route path="/datasource" element={<DataSourcePage />} />
              <Route path="/reports" element={<ReportsPage />} />
              <Route path="/templates" element={<TemplateMarketplace />} />
              <Route path="/custom-tables" element={<CustomTablePage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Suspense>
        </main>
      </div>
      <AiChat />
    </div>
  );
}

export default function App() {
  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        <Route path="/onboarding" element={<OnboardingPage />} />
        <Route path="/*" element={<MainLayout />} />
      </Routes>
    </Suspense>
  );
}
